import { INoNameContract } from '@amfi/connect-wallet/src/interface';
import Web3 from 'web3';

import {
  Chains,
  ChainType,
  contracts,
  ContractsNames,
  erc20Abi,
  erc721Abi,
  mogulBuyAbi,
  starsVestingSwapAbi,
} from './wallet-service';
import { MogulBuyAbi, StarsVestingSwapAbi } from './types/contracts';

export class ContractsService {
  private provider: Web3;

  constructor(provider: Web3) {
    this.provider = provider;
  }

  public getErc20Contract(tokenAddress: string) {
    return new this.provider.eth.Contract(erc20Abi, tokenAddress) as unknown as any;
  }

  public getErc721Contract(tokenAddress: string) {
    return new this.provider.eth.Contract(erc721Abi, tokenAddress) as unknown as any;
  }

  public getStarsVestingSwapContract(starsVestingSwapAddress: string) {
    return new this.provider.eth.Contract(
      starsVestingSwapAbi,
      starsVestingSwapAddress,
    ) as unknown as StarsVestingSwapAbi;
  }

  public getBuyContract(buyContractAddress: string) {
    return new this.provider.eth.Contract(mogulBuyAbi, buyContractAddress) as unknown as MogulBuyAbi;
  }

  public static getContractData(contractName: ContractsNames, network: Chains, chainType: ChainType): INoNameContract {
    const { abi, address } = contracts[contractName][chainType];
    return {
      address: address[network],
      abi,
    };
  }
}
